import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';

export const Card = styled('div')`
  background-color: ${({ theme }) => theme.colors.basics.white};
  border: 1px solid ${({ theme }) => theme.colors.gray.c4};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
`;

export const ErrorCard = styled('div')`
  background-color: ${({ theme }) => theme.colors.basics.white};
  border: 1px solid ${({ theme }) => theme.colors.spotlight.stage.deal.countBg};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
`;

export const DangerTextButton = styled('button')`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.system.lowFit};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 13px;
  padding: 0;
  text-decoration: underline;
`;

export const SetupStepsAnchor = styled(Flexbox)``;
